









import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})

export default class ProgressBar extends Vue {
    @Prop() progress: number;

    get $s() {
        return this.$style
    }
}

